<template>
  <div class="commercial-list">
    <former-container>
      <state-messages
        key="commercial-list-states"
        class="commercial-list-states"
        :state="currentState"
      >
        <template v-slot:loading>
          Carregando regras
        </template>

        <template v-slot:error>
          Algo deu errado enquanto tentávamos carregar as regras.
          Por favor, tente novamente.
        </template>

        <template v-slot:empty>
          Nenhuma regra encontrada
        </template>
      </state-messages>

      <template v-for="rule in currentRules">
        <former-section-list
          :key="rule.id"
          :editable="false"
          :section="sections(rule)"
          class="commercial-list-section"
        />

        <commercial-list-item
          :key="`rule-${rule.id}-actions`"
          :update-action="actions.update"
          :delete-action="actions.delete"
          :rule="rule"
          class="commercial-list-buttons"
          :loading="loading"
        />
      </template>
    </former-container>
  </div>
</template>

<script>
  import { input } from '@/_CRUDL/helpers/form/fields';
  import dataSort from '@/_CRUDL/helpers/data/sort';

  import CommercialListItem from '@/views/Settings/Commercial/List/Item.vue';

  import StateMessages from '@/components/State/Messages.vue';

  import FormerContainer from '@/components/Former/Container.vue';
  import FormerSectionList from '@/components/Former/Section/List.vue';

  export default {
    name: 'CommercialList',
    components: {
      CommercialListItem,
      StateMessages,
      FormerContainer,
      FormerSectionList,
    },
    props: {
      items: {
        type: Array,
        default() {
          return [];
        },
      },
      rules: {
        type: Object,
        default() {
          return {};
        },
      },
      actions: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      loading() {
        return this.rules.delete.loading;
      },
      currentRules() {
        const { items } = this.rules.list;

        return dataSort(items);
      },
      currentState() {
        const {
          error,
          items,
          loading,
        } = this.rules.list;

        if (loading) {
          return 'loading';
        }

        if (error) {
          return 'error';
        }

        return Object.keys(items).length ? 'ready' : 'empty';
      },
    },
    methods: {
      sections(rule) {
        const subtitle = [];

        const items = this.items.map(item => ({
          ...input,
          id: item.id,
          label: item.label,
          value: item.formatter ? item.formatter(rule[item.field]) : rule[item.field],
          mask: item.mask,
        }));

        const {
          bank,
          vehicle_model: vehicleModel,
        } = rule;

        if (bank || vehicleModel) {
          items.unshift({
            id: 'ruleSeparator',
            separator: true,
          });

          if (vehicleModel) {
            const {
              brand,
              name,
              version,
              year_start: yearStart,
              year_end: yearEnd,
            } = vehicleModel;

            const label = `${brand} ${name} ${version} (${yearStart} / ${yearEnd})`.replace(/^null$/g, '');

            subtitle.push(label);

            items.unshift({
              ...input,
              id: 'vehicleModel',
              label: 'Veículo',
              value: label,
            });
          }

          if (bank) {
            const { name } = rule.bank;

            subtitle.push(name);

            items.unshift({
              ...input,
              id: 'bank',
              label: 'Banco',
              value: name,
            });
          }
        }

        return {
          id: rule.id,
          title: rule.store.name,
          subtitle: subtitle.join(', ') || 'Aplicado a todos bancos e veículos',
          collapsable: true,
          startCollapsed: true,
          items,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .commercial-list-section {
    border-top: 1px solid $gray-dark;

    .commercial-list-states + & {
      border-top: none;
    }
  }

  .commercial-list-buttons {
    display: flex;
    padding: 0 var(--product--pwa--horizontal) $gutter-big;

    @media all and (min-width: $breakpoint-desktop) {
      padding: 0 var(--product--pwa--horizontal) $gutter-big;
    }

    .former-section-list-collapsed + & {
      display: none;
    }
  }
</style>
